"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePresentationControl = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _underscore = require("underscore");
var _StudioLogger = require("@studio/logger/StudioLogger");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var logger = new _StudioLogger.StudioLogger('presentation-control');
var usePresentationControl = exports.usePresentationControl = function usePresentationControl(_ref) {
  var _presentationValue$ac;
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$presentationValu = _ref.presentationValue,
    presentationValue = _ref$presentationValu === void 0 ? {} : _ref$presentationValu,
    _ref$onSourceChanged = _ref.onSourceChanged,
    onSourceChanged = _ref$onSourceChanged === void 0 ? function () {} : _ref$onSourceChanged;
  var activePage = (_presentationValue$ac = presentationValue === null || presentationValue === void 0 ? void 0 : presentationValue.activePage) !== null && _presentationValue$ac !== void 0 ? _presentationValue$ac : 1;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    numPages = _useState2[0],
    setNumPages = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showPrevPageNumber = _useState4[0],
    setShowPrevPageNumber = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    showNextPageNumber = _useState6[0],
    setShowNextPageNumber = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isDocumentLoaded = _useState8[0],
    setIsDocumentLoaded = _useState8[1];
  var _useState9 = (0, _react.useState)(activePage),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    inputPageNumber = _useState0[0],
    setInputPageNumber = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState1, 2),
    showInputForm = _useState10[0],
    setShowInputForm = _useState10[1];
  var presentationFooterRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setInputPageNumber(activePage);
  }, [activePage]);
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(pdf) {
    var numPages = pdf.numPages;
    setNumPages(numPages);
    setIsDocumentLoaded(true);
  };
  var onPageClick = function onPageClick(_pageNumber, _presentationValue) {
    onSourceChanged(id, _objectSpread(_objectSpread({}, _presentationValue), {}, {
      activePage: _pageNumber
    }));
  };
  var debouncedOnPageClick = (0, _react.useCallback)((0, _underscore.debounce)(onPageClick, 600, true), [id]);
  var leftThumbnailPage = activePage <= 1 ? 0 : activePage - 1;
  var rightThumbnailPage = activePage + 1;
  var goToNextPage = function goToNextPage() {
    var newPage = activePage + 1;
    debouncedOnPageClick(newPage, presentationValue);
    var presentation = {
      id: id,
      title: title,
      newPage: newPage,
      currentPage: activePage
    };
    logger.info('Presentation next page clicked', {
      presentation: presentation
    });
  };
  var goToPage = function goToPage(newPage) {
    debouncedOnPageClick(newPage, presentationValue);
    var presentation = {
      id: id,
      title: title,
      newPage: newPage,
      currentPage: activePage
    };
    logger.info('Presentation page input field updated', {
      presentation: presentation
    });
  };
  var goToPreviousPage = function goToPreviousPage() {
    var newPage = activePage - 1;
    debouncedOnPageClick(newPage, presentationValue);
    var presentation = {
      id: id,
      title: title,
      newPage: newPage,
      currentPage: activePage
    };
    logger.info('Presentation previous page clicked', {
      presentation: presentation
    });
  };
  var pageNumberInputHasError = inputPageNumber > numPages || inputPageNumber === 0;
  var handleClick = (0, _react.useCallback)(function (event) {
    var _presentationFooterRe, _presentationFooterRe2;
    var isOutsidePresentationFooterClick = (_presentationFooterRe = !(presentationFooterRef !== null && presentationFooterRef !== void 0 && (_presentationFooterRe2 = presentationFooterRef.current) !== null && _presentationFooterRe2 !== void 0 && _presentationFooterRe2.contains(event.target))) !== null && _presentationFooterRe !== void 0 ? _presentationFooterRe : false;
    setShowInputForm(!isOutsidePresentationFooterClick);
    if (isOutsidePresentationFooterClick) {
      setInputPageNumber(activePage);
    }
  }, [activePage]);
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
  var handlePageInputKeyPress = function handlePageInputKeyPress(event) {
    if (event.key === 'Enter' && !pageNumberInputHasError) {
      event.preventDefault();
      event.target.blur();
      setShowInputForm(false);
      goToPage(inputPageNumber);
    }
  };
  function handlePageInputChange(event) {
    if (isNaN(event.target.value)) {
      return;
    }
    setInputPageNumber(+event.target.value);
  }
  return {
    numPages: numPages,
    showPrevPageNumber: showPrevPageNumber,
    setShowPrevPageNumber: setShowPrevPageNumber,
    showNextPageNumber: showNextPageNumber,
    setShowNextPageNumber: setShowNextPageNumber,
    activePage: activePage,
    onDocumentLoadSuccess: onDocumentLoadSuccess,
    onPageClick: onPageClick,
    goToPreviousPage: goToPreviousPage,
    goToNextPage: goToNextPage,
    leftThumbnailPage: leftThumbnailPage,
    rightThumbnailPage: rightThumbnailPage,
    isDocumentLoaded: isDocumentLoaded,
    goToPage: goToPage,
    pageNumberInputHasError: pageNumberInputHasError,
    inputPageNumber: inputPageNumber,
    setInputPageNumber: setInputPageNumber,
    presentationFooterRef: presentationFooterRef,
    showInputForm: showInputForm,
    handlePageInputKeyPress: handlePageInputKeyPress,
    handlePageInputChange: handlePageInputChange,
    handleClick: handleClick
  };
};